module.exports = __webpack_public_path__ + "img/CZ28949587.6a90f55e.svg";